import * as Moment from 'moment';
import * as React from "react";

export interface AnalysisSetReferenceTagProps {
    typeName: string;
    coughSetTypeName: string;
    created: string;
    status: string;
}

export const AnalysisSetReferenceTag = (props: AnalysisSetReferenceTagProps) => {
    if (props.typeName) {
        return (
            <>
                {props.typeName} {props.coughSetTypeName} - {Moment(props.created).format("DD-MMM-YYYY HH:mm (Z)")} - ({props.status})
            </>
        );
    } else {
        return null;
    }
}
